import { i18n } from '@fs/zion-locale'
import chunk from 'lodash.chunk'
import { useMemo } from 'react'
import { useZionAxios } from '@fs/zion-axios'
import axios, { axiosThrottled } from './axios-retry'
import { extractPidsFromReservationList, mungeReservations } from './utils'

const RESERVATIONS_CALLS_PER_SEC = 4

export async function fetchReservations({ pids, cpUserId, isSharedWithTemple = false }) {
  const urls = pids.reduce((arr, nextBatchOfPids) => {
    const pidsList = nextBatchOfPids.join(',')
    const url = `/service/tree/tree-data/reservations/person/${pidsList}?locale=${i18n.language}&owner=${cpUserId}&pendingTransfer=true`
    arr.push(url)
    return arr
  }, [])
  const results = await axiosThrottled(urls, RESERVATIONS_CALLS_PER_SEC)
  const allRows = results.map((result) => result?.data?.data?.rows || []).flat()
  return mungeReservations({ allRows, sharedWithTemple: isSharedWithTemple, cpUserId })
}

export function fetchReservationsListCounts(cpUserId) {
  if (!cpUserId) return undefined
  const url = `/service/tree/tree-data/reservations/list/${cpUserId}/counts`
  return axios.get(url)
}

const BATCH_SIZE = 30

const transformResListPids = (res) => {
  if (res.statusMessage && res.statusMessage !== 'OK') throw new Error(res.statusMessage)
  if (!res.list) return null
  return extractPidsFromReservationList(res)
}

const transformResListPidsArray = (res) => {
  try {
    const parsedResponse = JSON.parse(res)
    return transformResListPids(parsedResponse)
  } catch (e) {
    console.error(`useReservationListPids: ${res} was returned and was not able to be parsed to JSON.`)
    return undefined
  }
}

export function useReservationListPids(cpUserId, isSharedWithTemple) {
  const [{ data: pids, loading, error }, refetch] = useZionAxios({
    url: cpUserId
      ? `/service/tree/tree-data/reservations/list/${cpUserId}?sharedWithTemple=${!!isSharedWithTemple}`
      : null,
    transformResponse: transformResListPidsArray,
  })
  const chunkedPids = useMemo(() => (pids ? chunk(pids, BATCH_SIZE) : undefined), [pids])

  return { chunkedPids, loading: loading || !cpUserId, error, refetch }
}
